var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main Ssdt"},[_c('Titledx',{attrs:{"text":"热点分类统计"}}),_c('div',{attrs:{"id":"echart_rdfx"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }